import React from "react"
import App from "../components/App/app"
import "../utils.css";

const IndexPage = () => (
  <App/>
)

export default IndexPage
